
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
const myColumns: any = [
  [
    {
      title: '公告日期',
      dataIndex: 'NoticeDateD',
      key: 'NoticeDateD',
      width: '100px',
      fixed: 'left'
    },
    {
      title: '股东名称',
      dataIndex: 'ShareholderName',
      key: 'ShareholderName',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '质押方',
      dataIndex: 'ReceiverName',
      key: 'ReceiverName',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '是否质押式回购',
      dataIndex: 'IfRepoD',
      key: 'IfRepoD',
      width: '110px'
    },
    {
      title: '质押股数 (股)',
      dataIndex: 'InvolvedSum',
      key: 'InvolvedSum',
      width: '110px',
      slots: { customRender: 'peopleCount' }
    },
    {
      title: '占总股本比例',
      dataIndex: 'CoverTotalShareRate',
      key: 'CoverTotalShareRate',
      width: '110px',
      slots: { customRender: 'nocolorincrease' }
    },
    {
      title: '占股东持股比例',
      dataIndex: 'CoverShareholderRate',
      key: 'CoverShareholderRate',
      width: '110px',
      slots: { customRender: 'nocolorincrease' }
    },
    {
      title: '质押起始日',
      dataIndex: 'StartTD',
      key: 'StartTD',
      width: '110px'
    },
    {
      title: '质押截止日',
      dataIndex: 'EndTD',
      key: 'EndTD',
      width: '110px'
    },
    {
      title: '解押日期',
      dataIndex: 'ReleaseTD',
      key: 'ReleaseTD',
      width: '110px'
    }
  ],
  [
    {
      title: '公告日期',
      dataIndex: 'NoticeDateD',
      key: 'NoticeDateD',
      width: '100px',
      fixed: 'left'
    },
    {
      title: '担保方',
      dataIndex: 'Guarantor',
      key: 'Guarantor',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '被担保方',
      dataIndex: 'Guaranteed',
      key: 'Guaranteed',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '担保金额(元)',
      dataIndex: 'GuaranteeAmount',
      key: 'GuaranteeAmount',
      width: '110px',
      slots: { customRender: 'peopleCount' }
    },
    {
      title: '币种',
      dataIndex: 'Currency',
      key: 'Currency',
      width: '110px'
    },
    {
      title: '担保期限(月）',
      dataIndex: 'GuaranteePeriod',
      key: 'GuaranteePeriod',
      width: '110px'
    },
    {
      title: '担保起始日',
      dataIndex: 'StartTD',
      key: 'StartTD',
      width: '110px'
    },
    {
      title: '担保终止日',
      dataIndex: 'EndTD',
      key: 'EndTD',
      width: '110px'
    },
    {
      title: '信息来源',
      dataIndex: 'InfoSource',
      key: 'InfoSource',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    }
  ],
  [
    {
      title: '公告日期',
      dataIndex: 'NoticeDateD',
      key: 'NoticeDateD',
      width: '100px',
      fixed: 'left'
    },
    {
      title: '信息来源',
      dataIndex: 'InfoSource',
      key: 'InfoSource',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '案由',
      dataIndex: 'Cause',
      key: 'Cause',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '案件简介',
      dataIndex: 'Brief',
      key: 'Brief',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '原告',
      dataIndex: 'Org',
      key: 'Org',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '被告',
      dataIndex: 'Defendant',
      key: 'Defendant',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '涉案金额(元)',
      dataIndex: 'RelatedAccount',
      key: 'RelatedAccount',
      width: '110px',
      slots: { customRender: 'peopleCount' }
    },
    {
      title: '币种',
      dataIndex: 'Currency',
      key: 'Currency',
      width: '110px'
    },
    {
      title: '诉讼仲裁审理机构',
      dataIndex: 'HearAgent',
      key: 'HearAgent',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '一审状态',
      dataIndex: 'FirstStatus',
      key: 'FirstStatus',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '二审状态',
      dataIndex: 'SecondStatus',
      key: 'SecondStatus',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '判决执行情况',
      dataIndex: 'ExecuteResult',
      key: 'ExecuteResult',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    }
  ],
  [
    {
      title: '公告日期',
      dataIndex: 'NoticeDateD',
      key: 'NoticeDateD',
      width: '100px',
      fixed: 'left'
    },
    {
      title: '类型',
      dataIndex: 'TheType',
      key: 'TheType',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '处罚对象',
      dataIndex: 'PenaltyObject',
      key: 'PenaltyObject',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '违规行为',
      dataIndex: 'Violations',
      key: 'Violations',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '违规条款',
      dataIndex: 'ViolationClause',
      key: 'ViolationClause',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '处分类型',
      dataIndex: 'DealType',
      key: 'DealType',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '处理人',
      dataIndex: 'TheHandler',
      key: 'TheHandler',
      width: '110px',
      ellipsis: true,
      slots: { customRender: 'ellipsis' }
    },
    {
      title: '处罚金额(元)',
      dataIndex: 'PenaltyAmount',
      key: 'PenaltyAmount',
      width: '110px',
      slots: { customRender: 'peopleCount' }
    },
    {
      title: '处罚币种',
      dataIndex: 'PenaltyCurrency',
      key: 'PenaltyCurrency',
      width: '110px'
    }
  ]
]
const tags = [
  {
    label: '股权质押',
    value: 1
  },
  {
    label: '对外担保',
    value: 2
  },
  {
    label: '诉讼仲裁',
    value: 3
  },
  {
    label: '违规处理',
    value: 4
  }
]

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const route = useRoute()
    const pageData: any = reactive({
      data: [],
      columns: [],
      tags: [],
      activeTagVal: 1,
      noDataTitle: '',
      spinning: true,
      noAllData: true,
      table2TdWidth: '160px'
    })
    pageData.noAllData = computed(() => {
      const _data = (props.pageSourceData || {}).MajorEvent || {}
      return _data.HasDataNum !== 0
    })
    pageData.noDataTitle = computed(() => {
      const res = pageData.tags.find((item: any) => {
        return item.value === pageData.activeTagVal
      })
      return res.label
    })
    pageData.tags = computed(() => {
      const _data = (props.pageSourceData || {}).MajorEvent || {}
      if (_data.IsStib === 1) {
        // 科创板
        return tags.slice(0, 1)
      } else {
        return tags
      }
    })
    function checkTag(tag: any) {
      pageData.spinning = true
      pageData.activeTagVal = tag.value
      getMajor()
    }

    pageData.columns = computed(() => {
      return myColumns[pageData.activeTagVal - 1]
    })

    const tooltip: any = reactive({})
    function handleEnter(e: any, key: any) {
      tooltip[key] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth // 溢出
    }
    const table2 = ref()
    function handlerTdWidth(val: any) {
      nextTick(() => {
        if (val) {
          if ((val || {}).length < 5) {
            pageData.table2TdWidth = table2.value && table2.value.clientWidth / pageData.data.length + 'px'
          } else {
            pageData.table2TdWidth = table2.value.clientWidth / 5 + 'px'
          }
        }
      })
    }
    const nameArr = ['StockRight', 'ExternalGuarantee', 'LitigateArbitrate', 'ViolationHandling']
    function getMajor() {
      const data: any = {}
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code,
        Opt: pageData.activeTagVal
      }
      data.headers = {
        token: props.token
      }
      f10Api.getMajor(data).then((res: any) => {
        nextTick(() => {
          pageData.spinning = false
        })
        if (!res || !res.Data) return
        const _data = res.Data[nameArr[pageData.activeTagVal - 1]]
        _data &&
          _data.forEach((element: any) => {
            element.NoticeDateD = element.NoticeDate && window.moment(element.NoticeDate * 1000).format('YYYY-MM-DD')
            element.StartTD = element.StartT && window.moment(element.StartT * 1000).format('YYYY-MM-DD')
            element.EndTD = element.EndT && window.moment(element.EndT * 1000).format('YYYY-MM-DD')
            element.ReleaseTD = element.ReleaseT && window.moment(element.ReleaseT * 1000).format('YYYY-MM-DD')
            element.GuaranteePeriodD = element.GuaranteePeriod && window.moment(element.GuaranteePeriod * 1000).format('YYYY-MM-DD')
            element.CoverTotalShareRate = element.CoverTotalShareRate * 100
            element.CoverShareholderRate = element.CoverShareholderRate * 100
            element.IfRepoD = element.IfRepo === 1 ? '是' : '否'
          })
        pageData.data = _data
        handlerTdWidth(pageData.data)
      })
    }
    getMajor()

    return {
      ...toRefs(pageData),
      checkTag,
      tooltip,
      handleEnter,
      table2
    }
  }
})
